import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onOpenAccount }) {
  const finalCta = useContent().finalCta;
  return (
    <section className="bg-white py-20">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl bg-[#16233d] px-8 lg:px-16 py-16 text-center overflow-hidden">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#b08d57]/10 blur-2xl" />
          <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-[#b08d57]/10 blur-2xl" />
          <div className="relative">
            <div className="gold-rule mx-auto mb-6" />
            <h2 className="font-serif-lux text-4xl lg:text-5xl text-white font-semibold">{finalCta.title}</h2>
            <p className="mt-4 text-white/60 text-lg max-w-xl mx-auto">{finalCta.text}</p>
            <button onClick={onOpenAccount} className="btn-gold rounded-md px-8 py-4 font-medium mt-8 inline-flex items-center gap-2">
              {finalCta.button} <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
